import { Stack } from "@mui/material";
import DataContainer from "../../../Utilities/DataContainer";
import RenderTextField from "../../../Utilities/Forms/RenderTextField";

interface IProps {
    isReadOnly: boolean;
}

export default function NearestSimilarSite({ isReadOnly }: IProps) {

    return (
        <DataContainer title="Nearest Similar Site">
            <Stack spacing={1}>
                <RenderTextField label="Name Of Nearest Similar Site" name="nameOfNearestSimilarSite" readOnly={isReadOnly} />
                <RenderTextField label="Distance To Nearest Similar Site" name="distanceToNearestSimilarSite" readOnly={isReadOnly} endAdornment="Km" />
            </Stack>
        </DataContainer>
    )
}